import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from '../../../../config/Translate';
import validator from 'validator';
import axios from 'axios';
import { defaultVariabls } from '../../../../config/index';
import { withRouter} from "react-router";
import {withSnackbar} from "notistack";
import LoadingButton from "../../../components/elements/LoadingButton";
import {connect} from "trim-redux";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import Thumbnail from "../../fileManager/Components/Thumbnail";
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import {checkMelliCode, updateRedux} from "../../../../config/Security";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import Typography from "@material-ui/core/Typography/Typography";
import UserCard from "../../../components/elements/UserCard";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import FieldCounterWithoutBar from "../../../components/elements/FieldCounterWithoutBar";
import SubTitleLight from "../../../components/elements/SubTitleLight";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import {Province} from "../../../components/elements/Province";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import FormControl from "@material-ui/core/FormControl/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import Rating from "@material-ui/lab/Rating/Rating";
import Button from "@material-ui/core/Button/Button";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import {shopTypesWithName} from "../../../../config/Permissions";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import SupplierTermsConfirmation from "../components/SupplierTermsConfirmation";
import SubTitle from "../../../components/elements/SubTitle";
import SingleFileChooser from "../../fileManager/Components/SingleFileChooser";
import FilesChooser from "../../fileManager/Components/FilesChooser";
import FileCopyRoundedIcon from '@material-ui/icons/FileCopyRounded';
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
class MakeShop extends React.Component {
    classes = this.props.classes;
    state={
        fields: {
            name: '',
            bio:'',
            description:'',
            address:'',
            postal_code:'',
            phone:'',
            financial_code:'',
            melli_code:'',
            worked_commission:'',
            new_commission:'',
            type:this.props.user.shop_type,
            identity:"real",
            owner_name:'',
            mobile:'',
            email:'',
            website:'',
            instagram:'',
            whatsapp:'',
            telegram:'',
            facebook:'',
            twitter:"",
            bale:"",
            contact_name:"",
            contact_mobile:"",
            contact_melli_code:"",
        },
        rating:4.5,
        province:null,
        cities: null,
        city:null,
        certificates:[],
        errors:{},
        loading:this.props.edit,
        SubmitLoading:false,
        policy_confirmation:true,
        editMode:this.props.edit,
        editModeP:this.props.edit,
        logo: 3,
        cover: null,
        cover_mobile: null,
        confirmed: 0,
        is_global: 0,
        show_email: 1,
        show_phone: 1,
        show_mobile: 1,
        accepted: 1,
        shop_id:this.props.shop_id,
        owner_id:null,
        melli_card_front:null,
        melli_card_back:null,
        melli_card_contact:null,
        slug:"",
        unique_code:"",
    };
    handleLogoImage(id){
        this.setState({
            logo: id
        })
    }
    handleCoverImage(id){
        this.setState({
            cover: id
        })
    }
    handleCoverMobileImage(id){
        this.setState({
            cover_mobile: id
        })
    }
    async componentDidMount(){

        if(!!this.state.editMode){
            await this.loadData();
        }
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.get(`${defaultVariabls.url}/shop/get/${this.state.shop_id}`, config)
            .then(response => {
                this.setState({
                    fields:{
                        name:response.data.name,
                        bio:!!response.data.bio ? response.data.bio : '',
                        new_commission:!!response.data.new_commission ? response.data.new_commission : '',
                        worked_commission:!!response.data.worked_commission ? response.data.worked_commission : '',
                        description:!!response.data.description ? response.data.description : '',
                        address:!!response.data.address ? response.data.address : '',
                        postal_code:!!response.data.postal_code ? response.data.postal_code : '',
                        phone:!!response.data.phone ? response.data.phone : '',
                        financial_code:!!response.data.financial_code ? response.data.financial_code : '',
                        melli_code:!!response.data.melli_code ? response.data.melli_code : '',
                        identity:!!response.data.identity ? response.data.identity : 'real',
                        type:!!response.data.type ? response.data.type : 'normal',
                        owner_name:!!response.data.owner_name ? response.data.owner_name : '',
                        mobile:!!response.data.mobile ? response.data.mobile : '',
                        email:!!response.data.email ? response.data.email : '',
                        website:!!response.data.website ? response.data.website : '',
                        instagram:!!response.data.instagram ? response.data.instagram : '',
                        whatsapp:!!response.data.whatsapp ? response.data.whatsapp : '',
                        telegram:!!response.data.telegram ? response.data.telegram : '',
                        facebook:!!response.data.facebook ? response.data.facebook : '',
                        twitter:!!response.data.twitter ? response.data.twitter : '',
                        bale:!!response.data.bale ? response.data.bale : '',
                        contact_name:!!response.data.contact_name ? response.data.contact_name : '',
                        contact_mobile:!!response.data.contact_mobile ? response.data.contact_mobile : '',
                        contact_melli_code:!!response.data.contact_melli_code ? response.data.contact_melli_code : '',
                    },
                    rating: response.data.average_rating,
                    province: response.data.province,
                    city: response.data.city,
                    certificates:!!response.data.certificates ? response.data.certificates : [],
                    logo: response.data.logo.id,
                    cover: response.data.cover,
                    cover_mobile: response.data.cover_mobile,
                    confirmed: response.data.confirmed,
                    is_global: response.data.is_global,
                    show_mobile: response.data.show_mobile,
                    accepted: response.data.accepted,
                    show_email: response.data.show_email,
                    show_phone: response.data.show_phone,
                    loading:false,
                    owner_id:response.data.user_id,
                    melli_card_front:response.data.melli_card_front,
                    melli_card_back:response.data.melli_card_back,
                    melli_card_contact:response.data.melli_card_contact,
                    slug:response.data.slug,
                    unique_code:response.data.unique_code,
                })
            })
            .catch(error => {
                console.log(error);
                this.props.enqueueSnackbar(Translate.dataFetchingError, {
                    variant: 'error',
                });
                this.setState({
                    loading:false
                })
            });
    }
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({
            fields,

        });
    }
    handleValidation(callback){
        let { fields,policy_confirmation,province,city,editMode,certificates,melli_card_front,melli_card_back,melli_card_contact } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(validator.isEmpty(fields.name)){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }else if(!validator.isByteLength(fields.name,{min:0, max:255})){
            formIsValid = false;
            errors['name'] = Translate.maxLength255;
        }

        //Bio
        if(fields.bio !== null ) {
            if (fields.bio.length > 50) {
                formIsValid = false;
                errors['bio'] = Translate.maxLength50;
            }
        }
        //policy_confirmation
        if(!editMode){
            if(!policy_confirmation ) {
                formIsValid = false;
                errors['policy_confirmation'] = Translate.pleaseCheckTheBox;
            }
        }

        //Commission
        if(fields.worked_commission !== null ) {
            if (parseInt(fields.worked_commission) > 100 || parseInt(fields.worked_commission) < 1) {
                formIsValid = false;
                errors['worked_commission'] = Translate.between0to100;
            }
        }
        if(fields.new_commission !== null ) {
            if (parseInt(fields.new_commission) > 100 || parseInt(fields.new_commission) < 1) {
                formIsValid = false;
                errors['new_commission'] = Translate.between0to100;
            }
        }

        //Description
        if(fields.description !== null ) {
            if (fields.description.length > 500) {
                formIsValid = false;
                errors['description'] = Translate.maxLength500;
            }
        }
        //province
        if(!province) {
            formIsValid = false;
            errors['province'] = Translate.emptyField;
        }
        //city
        if(!city) {
            formIsValid = false;
            errors['city'] = Translate.emptyField;
        }
        //address
        if(!fields.address) {
            formIsValid = false;
            errors['address'] = Translate.emptyField;
        }
        /*//phone
        if(!fields.phone) {
            if(fields.type !== "virtual_store" && fields.type !== "normal" && fields.identity !== "real"){
                formIsValid = false;
                errors['phone'] = Translate.emptyField;
            }
        }*/
        if(!fields.postal_code){
            formIsValid = false;
            errors['postal_code'] = Translate.emptyField;
        }

        if(!fields.mobile){
            formIsValid = false;
            errors['mobile'] = Translate.emptyField;
        }
        if(!fields.email){
            formIsValid = false;
            errors['email'] = Translate.emptyField;
        }
        if(!!fields.contact_melli_code){
            if(!checkMelliCode(fields.contact_melli_code)){
                formIsValid = false;
                errors['contact_melli_code'] = Translate.wrongMelliCode;
            }
        }
        if(!melli_card_back){
            formIsValid = false;
            errors['melli_card_back'] = Translate.emptyField;
        }
        if(!melli_card_front){
            formIsValid = false;
            errors['melli_card_front'] = Translate.emptyField;
        }

        if(!fields.owner_name){
            formIsValid = false;
            errors['owner_name'] = Translate.emptyField;
        }
        if(certificates.length === 0){
            if(fields.type !== "virtual_store" && fields.type !== "normal"){
                formIsValid = false;
                errors['certificates'] = Translate.emptyField;
            }
        }
        if(!fields.melli_code){
            formIsValid = false;
            errors['melli_code'] = Translate.emptyField;
        }
        if(fields.identity === "real"){
            if(!!fields.melli_code){
                if(!checkMelliCode(fields.melli_code)){
                    formIsValid = false;
                    errors['melli_code'] = Translate.wrongMelliCode;
                }
            }
        }
        if(fields.identity === "legal"){
            if(!fields.contact_melli_code){
                formIsValid = false;
                errors['contact_melli_code'] = Translate.emptyField;
            }
            if(!fields.contact_name){
                formIsValid = false;
                errors['contact_name'] = Translate.emptyField;
            }
            if(!fields.contact_mobile){
                formIsValid = false;
                errors['contact_mobile'] = Translate.emptyField;
            }
            if(!melli_card_contact){
                formIsValid = false;
                errors['melli_card_contact'] = Translate.emptyField;
            }
            if(!!fields.contact_melli_code){
                if(!checkMelliCode(fields.contact_melli_code)){
                    formIsValid = false;
                    errors['contact_melli_code'] = Translate.wrongMelliCode;
                }
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasErrorPleaseCheckThem, {
                variant: 'warning',
            });
            this.setState({
                SubmitLoading:false,
                errors
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let {user} = this.props;
        if(!user.last_name || !user.first_name){
            this.props.enqueueSnackbar(Translate.pleaseCompleteYourInfoFirst, {
                variant: 'error',
            });
            return false
        }else{
            const {fields,logo,cover,cover_mobile,rating,shop_id,
                confirmed,is_global,show_mobile,show_email,show_phone,certificates,province,city,
                melli_card_front,melli_card_back,melli_card_contact,accepted,
            } = this.state;
            let {new_request} = this.props;
            let data = new FormData();
            let certificates_id = [];
            if(!!certificates){
                certificates.map((cartificate)=>{
                    certificates_id.push(cartificate.id);
                })
            }
            data.append('name', fields.name);
            data.append('type', fields.type);
            data.append('identity', fields.identity);
            data.append('bio', fields.bio);
            data.append('description', fields.description);
            data.append('worked_commission', fields.worked_commission);
            data.append('new_commission', fields.new_commission);
            data.append('id', shop_id);
            data.append('average_rating', rating);
            data.append('user_id', this.props.user.id);
            data.append('logo', logo);
            data.append('confirmed', confirmed ? 1 : 0);
            data.append('is_global', is_global ? 1 : 0);
            data.append('show_phone', show_phone ? 1 : 0);
            data.append('show_mobile', show_mobile ? 1 : 0);
            data.append('accepted', accepted ? 1 : 0);
            data.append('show_email', show_email ? 1 : 0);
            data.append('cover', !!cover ? cover.id : '');
            data.append('cover_mobile', !!cover_mobile ? cover_mobile.id : '');
            data.append('certificates', JSON.stringify(certificates_id));
            data.append('province', province);
            data.append('city', city);
            data.append('address', fields.address);
            data.append('postal_code', fields.postal_code);
            data.append('financial_code', fields.financial_code);
            data.append('phone', fields.phone);
            data.append('melli_code', fields.melli_code);
            data.append('owner_name', fields.owner_name);
            data.append('email', fields.email);
            data.append('mobile', fields.mobile);
            data.append('instagram', fields.instagram);
            data.append('whatsapp', fields.whatsapp);
            data.append('telegram', fields.telegram);
            data.append('facebook', fields.facebook);
            data.append('twitter', fields.twitter);
            data.append('bale', fields.bale);
            data.append('website', fields.website);
            data.append('contact_name', fields.contact_name);
            data.append('contact_mobile', fields.contact_mobile);
            data.append('contact_melli_code', fields.contact_melli_code);
            data.append('melli_card_front', !!melli_card_front ? melli_card_front.id : null);
            data.append('melli_card_back', !!melli_card_back ? melli_card_back.id : null);
            data.append('melli_card_contact', !!melli_card_contact ? melli_card_contact.id : null);

            if (city !== null ){
                if(city.name === undefined){
                    data.append('city', city);
                }else {
                    data.append('city', city.name);
                }
            }
            if (province !== null ){
                if(province.name === undefined){
                    data.append('province', province);
                }else{
                    data.append('province', province.name);
                }
            }
            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariabls.url}/shop/make`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.detailsSet, {
                        variant: 'success',
                    });
                    this.setState({
                        SubmitLoading:false
                    });
                    updateRedux();
                    if(!this.state.editMode){
                        if(new_request){
                            window.open(`${defaultVariabls.React}/request/supplier`,'_self');

                        }else{
                            if(!!user.role.permission.manageShops){
                                this.props.history.push(`/manage/shops`);
                            }else{
                                window.open(`${defaultVariabls.React}/my-shop`,'_self');
                            }
                        }

                    }

                })

                .catch(error => {
                    if(error.response.status === 401){
                        this.props.enqueueSnackbar(Translate.someFieldsHasErrorPleaseCheckThem, {
                            variant: 'warning',
                        });
                        let errors = this.state.errors;
                        if(!!error.response.data.name){
                            errors['name'] = Translate[error.response.data.name];
                        }
                        if(!!error.response.data.mobile){
                            errors['mobile'] = Translate[error.response.data.mobile];
                        }
                        if(!!error.response.data.email){
                            errors['email'] = Translate[error.response.data.email];
                        }
                        if(!!error.response.data.contact_mobile){
                            errors['contact_mobile'] = Translate[error.response.data.contact_mobile];
                        }
                        if(!!error.response.data.contact_mobile){
                            errors['contact_mobile'] = Translate[error.response.data.contact_mobile];
                        }
                        if(!!error.response.data.contact_melli_code){
                            errors['contact_melli_code'] = Translate[error.response.data.contact_melli_code];
                        }
                        if(!!error.response.data.melli_code){
                            errors['melli_code'] = Translate[error.response.data.melli_code];
                        }
                        this.setState({
                            errors
                        })
                    }else if(error.response.status === 403){
                        if(error.response.data === "first_confirm_user"){
                            this.props.enqueueSnackbar(Translate.firstConfirmUser, {
                                variant: 'error',
                            });
                            this.setState({
                                confirmed:0
                            })
                        }
                    }else{
                        this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                            variant: 'error',
                        });
                    }
                    console.log(error.response);

                    this.setState({
                        SubmitLoading:false
                    });

                });
        }
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }

        });
    }
    handleChangeConfirmed(){
        this.setState({
            confirmed: !this.state.confirmed,
        })
    }
    handleChangeIsGlobal(){
        this.setState({
            is_global: !this.state.is_global,
        })
    }
    handleChangeShow(item){
        alert(this.state[item])
    }
    handChangeProvince(province){
        if (province === null){
            this.setState({
                province,
                cities:null,
                city:null
            })
        }else{
            this.setState({
                province,
                cities: province.Cities,
            })
        }

    }
    handChangeCity(city){
        this.setState({
            city
        })
    }
    handleNotAccpeted(){
        this.setState({
            accepted: 0
        })
    }
    handleClickLink(){
        let link = `${defaultVariabls.website}/vendor/${this.state.slug}`
        navigator.clipboard.writeText(link);
        this.props.enqueueSnackbar(Translate.linkCopied, {
            variant: 'info',
        });
    }
    render() {
        const {errors,logo,rating,policy_confirmation,province,city,fields,SubmitLoading,editMode,editModeP,confirmed,
            cover,cover_mobile,show_phone,show_mobile,show_email,accepted,
            certificates,owner_id,
            melli_card_front,melli_card_back,melli_card_contact
        } = this.state;
        const {user,new_request} = this.props;
        if (this.state.loading) {
            return (
                <AppCardLoaderFields/>
            )
        } else {
            return (
                <form autoComplete="off" role="presentation">
                    <input autoComplete="false" name="hidden" type="text" style={{display:"none"}}/>
                    <Grid container  spacing={2} justify="center" >
                        <CssBaseline/>
                        {
                            !editMode &&
                            <SupplierTermsConfirmation handleNotAccepeted={() => this.handleNotAccpeted()}/>
                        }
                        <Grid item xs={12} md={11} lg={10}  style={{marginTop:20}}>
                            <Grid container spacing={2} direction="row" justify="center"  alignItems="flex-end">
                                {
                                    accepted !== 1 &&
                                    <Grid item xs={12}>
                                        <Alert
                                            severity="error"
                                            action={
                                                user.role.name === 'admin' &&
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    color="inherit"
                                                    onClick={() => this.setState({accepted:1})}
                                                >
                                                    {Translate.accepted}

                                                </Button>

                                            }
                                        >
                                            {Translate.rullesNotAccepted}
                                        </Alert>
                                    </Grid>
                                }
                                <Grid item xs={12}>
                                    {
                                        !editMode ?
                                            <Alert severity="info">
                                                <AlertTitle>{Translate.welcomeShopCreatorTitle}</AlertTitle>
                                                {Translate.WelcomeShopCreatorText} <strong>{Translate.thankYou}</strong>
                                            </Alert>
                                            :
                                            <>
                                                {
                                                    !! user.role.permission.manageShops ?
                                                        <>
                                                            <Alert
                                                                severity="info"
                                                                action={
                                                                    <div style={{display:"flex",alignItems:"center"}}>
                                                                        <FormControlLabel
                                                                            style={{marginRight:10,color: !confirmed ? "#ed1d1d" : ""}}
                                                                            control={
                                                                                <Switch
                                                                                    checked={confirmed}
                                                                                    onChange={this.handleChangeConfirmed.bind(this)}
                                                                                    value={confirmed}
                                                                                    color="primary"
                                                                                />
                                                                            }
                                                                            label={confirmed ? Translate.confirmed : Translate.unConfirmed}
                                                                        />
                                                                        <LoadingButton
                                                                            variant="contained"
                                                                            color="primary"
                                                                            size="small"
                                                                            styleForParent={{margin:0}}
                                                                            onClick = {this.handleSubmit.bind(this)}
                                                                            loading = {SubmitLoading}
                                                                        >
                                                                            {Translate.save}
                                                                        </LoadingButton>
                                                                    </div>

                                                                }
                                                            >
                                                                {Translate.confirmationStatus}
                                                            </Alert>
                                                            <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                                                                <Grid item xs={12} md={6}>
                                                                    <Typography style={{marginTop:10}}>
                                                                        <span style={{marginLeft:10}}>{Translate.shopLink}:</span>
                                                                        <Button
                                                                            dir="ltr"
                                                                            color="primary"
                                                                            style={{textTransform:"lowercase"}}
                                                                            size="small"
                                                                            variant="contained"
                                                                            startIcon={<FileCopyRoundedIcon style={{marginRight:10,marginLeft:0}}/>}
                                                                            onClick={() =>this.handleClickLink()}
                                                                        >
                                                                            {`${defaultVariabls.website}/vendor/${this.state.slug}`}
                                                                        </Button>
                                                                    </Typography>
                                                                    <Typography style={{marginTop:5}}>{Translate.shop_link_hint}</Typography>
                                                                </Grid>
                                                                <Grid item xs={12} md={6} style={{textAlign:"left"}}>
                                                                    <Typography>{Translate.shop_unique_key}: <strong>{this.state.unique_code}</strong></Typography>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container spacing={2} alignItems="center" className="mt-15">
                                                                <Grid item xs={12} md={6}>
                                                                    <Typography>{Translate.shopTotalRating}:</Typography>
                                                                    <Rating
                                                                        name="rating"
                                                                        precision={0.5}
                                                                        value={rating}
                                                                        onChange={(event, newValue) => {
                                                                            this.setState({
                                                                                rating:newValue,
                                                                            })
                                                                        }}
                                                                    />
                                                                    <Typography className="litle_description_text">{Translate.productTotalRatingDesc}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                        :
                                                        confirmed ?
                                                            <>
                                                                <Alert  severity="success">
                                                                    {Translate.yourShopIsActive}
                                                                </Alert>
                                                                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                                                                    <Grid item xs={12} md={6}>
                                                                        <Typography style={{marginTop:10}}>
                                                                            <span style={{marginLeft:10}}>{Translate.shopLink}:</span>
                                                                            <Button
                                                                                dir="ltr"
                                                                                color="primary"
                                                                                style={{textTransform:"lowercase"}}
                                                                                size="small"
                                                                                variant="contained"
                                                                                startIcon={<FileCopyRoundedIcon style={{marginRight:10,marginLeft:0}}/>}
                                                                                onClick={() =>this.handleClickLink()}
                                                                            >
                                                                                {`${defaultVariabls.website}/vendor/${this.state.slug}`}
                                                                            </Button>
                                                                        </Typography>
                                                                        <Typography style={{marginTop:5}}>{Translate.shop_link_hint}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={6} style={{textAlign:"left"}}>
                                                                        <Typography>{Translate.shop_unique_key}: <strong>{this.state.unique_code}</strong></Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </>

                                                            :
                                                            <Alert severity="warning">
                                                                {Translate.yourShopIsInchecking}
                                                            </Alert>
                                                }
                                            </>

                                    }
                                </Grid>
                                {
                                    !!user.role.permission.manageShops &&
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.new_commission}
                                                fullWidth
                                                size="small"
                                                type="number"
                                                label={Translate.new_commission}
                                                name="new_commission"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['new_commission']}
                                                helperText={errors['new_commission']}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            %
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.worked_commission}
                                                fullWidth
                                                size="small"
                                                type="number"
                                                label={Translate.worked_commission}
                                                name="worked_commission"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['worked_commission']}
                                                helperText={errors['worked_commission']}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            %
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </>
                                }
                                <Grid item xs={12}>
                                    <SubTitle align="left">{Translate.shopInfo}</SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <Alert severity="info">
                                        {Translate.staredInputsAreRequired}
                                    </Alert>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <SubTitleLight align="left">{Translate.cover}</SubTitleLight>
                                    <Typography paragraph>{Translate.coverSizeGuide}</Typography>
                                    <SingleImageChooser
                                        primary
                                        cover
                                        large
                                        onChange={(cover) => this.handleCoverImage(cover)}
                                        initial={cover}
                                        defined_width={1320}
                                        defined_height={250}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <SubTitleLight align="left">{Translate.cover_mobile}</SubTitleLight>
                                    <Typography paragraph>{Translate.coverMobileSizeGuide}</Typography>
                                    <SingleImageChooser
                                        primary
                                        cover
                                        large
                                        onChange={(cover) => this.handleCoverMobileImage(cover)}
                                        initial={cover_mobile}
                                        defined_width={750}
                                        defined_height={250}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <SubTitleLight>{Translate.logo}</SubTitleLight>
                                    <Thumbnail logo
                                               handleThumbImage={this.handleLogoImage.bind(this)}
                                               initial={logo} size={170}/>
                                </Grid>
                                <Grid item xs={12} md={9}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                required
                                                value={fields.name}
                                                fullWidth
                                                id="name"
                                                label={Translate.shopName}
                                                name="name"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['name']}
                                                helperText={errors['name']}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                required
                                                value={fields.type}
                                                fullWidth
                                                select
                                                label={Translate.shopType}
                                                name="type"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['type']}
                                                helperText={errors['type']}
                                            >
                                                {
                                                    shopTypesWithName.map((item,index) => (
                                                            <MenuItem key={index} value={item.value}>
                                                                {item.name} <span className="menu_sub"> ({item.description})</span>
                                                            </MenuItem>
                                                        )
                                                    )
                                                }
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.bio}
                                                fullWidth
                                                id="bio"
                                                label={Translate.bio}
                                                placeholder={Translate.bioDescription}
                                                name="bio"
                                                autoComplete="bio"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['bio']}
                                                helperText={errors['bio']}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <FieldCounterWithoutBar length={fields.bio.length} max={50}/>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                variant="outlined"
                                                value={fields.description}
                                                fullWidth
                                                id="description"
                                                label={Translate.shopDescription}
                                                name="description"
                                                multiline
                                                minRows={3}
                                                maxRows={5}
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['description']}
                                                helperText={errors['description']}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <FieldCounterWithoutBar length={fields.description.length} max={500}/>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.website}
                                        fullWidth
                                        label={Translate.website}
                                        name="website"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['website']}
                                        helperText={errors['website']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.instagram}
                                        fullWidth
                                        label={Translate.instagram}
                                        name="instagram"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['instagram']}
                                        helperText={errors['instagram']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.facebook}
                                        fullWidth
                                        label={Translate.facebook}
                                        name="facebook"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['facebook']}
                                        helperText={errors['facebook']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.twitter}
                                        fullWidth
                                        label={Translate.twitter}
                                        name="twitter"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['twitter']}
                                        helperText={errors['twitter']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.telegram}
                                        fullWidth
                                        label={Translate.telegram}
                                        name="telegram"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['telegram']}
                                        helperText={errors['telegram']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.whatsapp}
                                        fullWidth
                                        label={Translate.whatsapp}
                                        name="whatsapp"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['whatsapp']}
                                        helperText={errors['whatsapp']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.bale}
                                        fullWidth
                                        label={Translate.bale}
                                        name="bale"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['bale']}
                                        helperText={errors['bale']}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <SubTitle align="left">{Translate.owningInfo}</SubTitle>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        value={fields.identity}
                                        fullWidth
                                        select
                                        label={Translate.identity}
                                        name="identity"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['identity']}
                                        helperText={errors['identity']}
                                    >
                                        <MenuItem value="real">
                                            {Translate.real}
                                        </MenuItem>
                                        <MenuItem value="legal">
                                            {Translate.legal}
                                        </MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.melli_code}
                                        fullWidth
                                        required
                                        label={fields.identity === "real" ? Translate.melli_code : Translate.melli_code_compnay}
                                        name="melli_code"
                                        type="number"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['melli_code']}
                                        helperText={errors['melli_code']}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.owner_name}
                                        fullWidth
                                        required
                                        label={fields.identity === "real" ? Translate.fullName : Translate.company_name}
                                        name="owner_name"
                                        type="text"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['owner_name']}
                                        helperText={errors['owner_name']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    {
                                        editModeP ?
                                            <TextField
                                                required
                                                autoComplete="do-not-autofill"
                                                label={Translate.province}
                                                variant="outlined"
                                                fullWidth
                                                disabled
                                                value={province}
                                            />
                                            :
                                            <Autocomplete
                                                options={Province}
                                                required
                                                autoComplete="do-not-autofill"
                                                onChange={(event, value) => this.handChangeProvince(value)}
                                                getOptionLabel={option => option.name}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                        label={Translate.province}
                                                        variant="outlined"
                                                        value={province}
                                                        fullWidth
                                                        autoComplete="do-not-autofill"
                                                        error = {!!errors['province']}
                                                        helperText={errors['province']}
                                                    />
                                                )}
                                            />
                                    }

                                </Grid>
                                <Grid item xs={12} md={6} style={{position:"relative"}}>
                                    {
                                        editModeP ?
                                            <TextField
                                                required
                                                autocomplete="off"
                                                label={Translate.city}
                                                variant="outlined"
                                                fullWidth
                                                disabled
                                                value={city}
                                            />
                                            :
                                            <Autocomplete
                                                options={this.state.cities}
                                                onChange={(event, value) => this.handChangeCity(value)}
                                                getOptionLabel={option => option.name}
                                                value={city}
                                                required
                                                disabled={this.state.cities === null}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                        autocomplete="off"
                                                        label={Translate.city}
                                                        variant="outlined"
                                                        fullWidth
                                                        error = {!!errors['city']}
                                                        helperText={errors['city']}
                                                    />
                                                )}
                                            />
                                    }
                                    {
                                        (!!user.role.permission.manageShops && editModeP) &&
                                        <div style={{position:"absolute",left:12,zIndex:999,top:13}}>
                                            <Tooltip title={Translate.changeProvinceAndCity}>
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => this.setState({
                                                        province:null,
                                                        city:null,
                                                        editModeP:false,
                                                    })}
                                                >
                                                    <EditRoundedIcon/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.address}
                                        fullWidth
                                        required
                                        label={Translate.address}
                                        name="address"
                                        minRows={4}
                                        maxRows={5}
                                        multiline
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['address']}
                                        helperText={errors['address']}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <FieldCounterWithoutBar length={fields.address.length} max={500}/>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.postal_code}
                                        fullWidth
                                        required
                                        label={Translate.postal_code}
                                        name="postal_code"
                                        type="number"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['postal_code']}
                                        helperText={errors['postal_code']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.phone}
                                        fullWidth
                                        label={Translate.phone}
                                        name="phone"
                                        type="number"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['phone']}
                                        helperText={errors['phone']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.mobile}
                                        fullWidth
                                        required
                                        label={Translate.mobile}
                                        name="mobile"
                                        type="number"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['mobile']}
                                        helperText={errors['mobile']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.email}
                                        fullWidth
                                        required
                                        label={Translate.email}
                                        name="email"
                                        type="email"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['email']}
                                        helperText={errors['email']}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl required  component="fieldset">
                                        <FormControlLabel
                                            control={<Checkbox checked={show_phone} onChange={() => this.setState({show_phone:!show_phone})} />}
                                            label={
                                                <Typography className="privacy_policy">
                                                    {Translate.show_phone}
                                                </Typography>
                                            }
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={show_mobile} onChange={() => this.setState({show_mobile:!show_mobile})} />}
                                            label={
                                                <Typography className="privacy_policy">
                                                    {Translate.show_mobile}
                                                </Typography>
                                            }
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={show_email} onChange={() => this.setState({show_email:!show_email})} />}
                                            label={
                                                <Typography className="privacy_policy">
                                                    {Translate.show_email}
                                                </Typography>
                                            }
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <SubTitle align="left">{Translate.contactInfo}</SubTitle>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required={fields.identity === "legal"}
                                        variant="outlined"
                                        value={fields.contact_name}
                                        fullWidth
                                        label={Translate.contact_name}
                                        name="contact_name"
                                        type="text"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['contact_name']}
                                        helperText={errors['contact_name']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required={fields.identity === "legal"}
                                        variant="outlined"
                                        value={fields.contact_mobile}
                                        fullWidth
                                        label={Translate.contact_mobile}
                                        name="contact_mobile"
                                        type="number"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['contact_mobile']}
                                        helperText={errors['contact_mobile']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required={fields.identity === "legal"}
                                        variant="outlined"
                                        value={fields.contact_melli_code}
                                        fullWidth
                                        label={Translate.contact_melli_code}
                                        name="contact_melli_code"
                                        type="number"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['contact_melli_code']}
                                        helperText={errors['contact_melli_code']}
                                    />
                                </Grid>
                                {
                                    !editMode &&
                                    <Grid item xs={12}>
                                        <FormControl required error={!!errors['policy_confirmation']} component="fieldset">
                                            <FormControlLabel
                                                control={<Checkbox checked={policy_confirmation} onChange={() => this.setState({policy_confirmation:!policy_confirmation})} />}
                                                label={
                                                    <Typography align="center" className="privacy_policy text-center">
                                                        {new_request ? Translate.withRequestingShop : Translate.withCreateShop}
                                                        {" "}
                                                        <a target="_blank" href={`${defaultVariabls.website}/supplier-terms`} >
                                                            {Translate.shopRules}
                                                        </a>
                                                        {" "}
                                                        {Translate.privacyPolicyConfirmationShop}
                                                    </Typography>
                                                }
                                            />
                                            {
                                                !!errors['policy_confirmation'] &&
                                                <FormHelperText>{errors['policy_confirmation']}</FormHelperText>

                                            }
                                        </FormControl>
                                    </Grid>
                                }
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6} style={{marginTop:25}}>
                                        <SingleFileChooser
                                            required
                                            title={Translate.melli_card_front}
                                            onChange={(melli_card_front) =>this.setState({melli_card_front,errors:[]})}
                                            initial={melli_card_front}
                                            type="image"
                                        />
                                        {
                                            !!errors['melli_card_front'] &&
                                            <Typography className="error-text">{errors['melli_card_front']}</Typography>
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={6} style={{marginTop:25}}>
                                        <SingleFileChooser
                                            required
                                            title={Translate.melli_card_back}
                                            onChange={(melli_card_back) =>this.setState({melli_card_back,errors:[]})}
                                            initial={melli_card_back}
                                            type="image"
                                        />
                                        {
                                            !!errors['melli_card_back'] &&
                                            <Typography className="error-text">{errors['melli_card_back']}</Typography>
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={6} style={{marginTop:25}}>
                                        <SingleFileChooser
                                            required={fields.identity === "legal"}
                                            title={Translate.melli_card_contact}
                                            onChange={(melli_card_contact) =>this.setState({melli_card_contact,errors:[]})}
                                            initial={melli_card_contact}
                                            type="image"
                                        />
                                        {
                                            !!errors['melli_card_contact'] &&
                                            <Typography className="error-text">{errors['melli_card_contact']}</Typography>
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={6} style={{marginTop:25}}>
                                        <FilesChooser
                                            required={fields.type !== "virtual_store" && fields.type !== "normal"}
                                            align_left
                                            title={Translate.certificationFile}
                                            onChange={(certificates) =>this.setState({certificates})}
                                            initial={certificates}
                                            max={3}
                                        />
                                        {
                                            !!errors['certificates'] &&
                                            <Typography className="error-text">{errors['certificates']}</Typography>
                                        }
                                    </Grid>
                                </Grid>
                                {
                                    !! user.role.permission.manageShops && !!editMode &&
                                    <Grid item xs={12} style={{marginTop:20}}>
                                        <UserCard title={Translate.shopOwner} id={owner_id}/>
                                    </Grid>
                                }
                                <Grid item xs={12}>
                                    <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        onClick = {this.handleSubmit.bind(this)}
                                        loading = {SubmitLoading}
                                    >
                                        {editMode ? Translate.setDetails  : Translate.makeShop}
                                    </LoadingButton>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            );
        }
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MakeShop))));